import { render, staticRenderFns } from "./CreateSampleButton.vue?vue&type=template&id=8ec4d274&"
import script from "./CreateSampleButton.vue?vue&type=script&lang=js&"
export * from "./CreateSampleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports